import { useEffect } from 'react';

export const VH_100 = 'calc(var(--vh, 1vh) * 100)';

const use100vh = () => {
  const setVh = () => {
    document.documentElement.style.setProperty(
      '--vh',
      `${window.innerHeight * 0.01}px`,
    );
  };

  useEffect(() => {
    setVh();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', setVh);
    }
    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);

  return { VH_100 };
};

export default use100vh;
